module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "single-select"
  }, [_c('div', {
    staticClass: "single-select__trigger",
    class: {
      isActive: _vm.dropdown
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "single-select__title"
  }, [_vm._v(_vm._s(_vm.data.displayname))]), _vm._v(" "), _c('span', {
    staticClass: "single-select__value",
    class: {
      hidden: _vm.data.checkedFilters.length == 0
    }
  }, [_vm._v(_vm._s(_vm.data.checkedFilters[0]))]), _vm._v(" "), _c('span', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 129 129"
    }
  }, [_c('path', {
    attrs: {
      "d": "M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"
    }
  })])])]), _vm._v(" "), _c('div', {
    ref: "dropdown",
    staticClass: "single-select__dropdown",
    class: {
      activeSearch: _vm.showLoader
    }
  }, [_c('div', {
    staticClass: "single-select__search-wrapp",
    class: {
      hidden: _vm.data.filters.length < 6
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "txt_search",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "single-select__filters-wrapp"
  }, _vm._l((_vm.filteredList), function(filter, index) {
    return _c('li', {
      class: {
        selected: filter == _vm.data.checkedFilters[0]
      },
      on: {
        "click": function($event) {
          _vm.selectItem(index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(filter) + "\n                ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d14773c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleSelect.vue
// module id = 486
// module chunks = 2